import { BlobCreate } from "@pdfking/compatibility"
import {
  JSON_REDIRECT_CONTENT_TYPE,
  PARSABLE_COMMENT,
} from "@pdfking/constants/settings"
import { first, scan } from "@pdfking/rfunc"
import {
  IsString,
  JSONDecode,
  ResponseContentType,
  ResponseFileName,
  ResponseHeader,
} from "@pdfking/tfunc"
import { FETCH } from "@pdfking/translations/enum/trackers"
import fire_event from "@pdfking/workflow/utils/fire_event"
import { startswith } from "@pdfking/workflow/utils/strings"
import track_promise from "@pdfking/workflow/utils/track_promise"
import { url_parse } from "@pdfking/workflow/utils/urlutilities"
import uuid from "@pdfking/workflow/utils/uuid"
import download_url from "src/files/actions/download_url"
import el from "../dom/element"
import selector from "../dom/selector"
import state from "../state/main"
import navigator from "../state/navigator"
import scroll_to from "../utils/scroll_to"
import change_window_location from "./change_window_location"
import check_url_is_ajax from "./check_url_is_ajax"

function data_to_form_data(data) {
  if (IsString(data)) {
    const params = new URLSearchParams(data)
    const temp = new FormData()

    for (const [k, v] of params.entries()) {
      temp.append(k, v)
    }

    return temp
  }

  return data
}

const read = (url, data) =>
  track_promise(
    _emit =>
      fetch(
        url,
        data
          ? {
              body: data_to_form_data(data),
              method: "post",
            }
          : null
      ),
    // @ts-expect-error TS2322
    emit => emit({ done: 0, name: FETCH, total: 1 }),
    // @ts-expect-error TS2322
    emit => emit({ done: 1, name: FETCH, total: 1 })
  )

export default (
  url,
  {
    change_location = true,
    data = null,
    oncomplete = () => {},
    scroll_control = true,
  }
) => {
  // @ts-expect-error TS2339
  if (!state.IS_SUBMITTED) {
    const input = first(selector(":focus"))

    console.info("start_request: ", { data, url })

    // @ts-expect-error TS2339
    state.IS_SUBMITTED = true
    // @ts-expect-error TS2339
    state.LAST_FOCUS = input ? input.id : null
    // @ts-expect-error TS2339
    state.AJAX_COUNTER += 1
    // @ts-expect-error TS2339
    state.request_id = uuid()

    const parsed = url_parse(url)

    read(parsed.href, data).then(async response => {
      const text = await response.clone().text()

      const path = url_parse(
        ResponseHeader(response, "X-Real-Path") || response.url
      )
      const mode = ResponseHeader(response, "X-Change-Location")
      const cttp = ResponseContentType(response)

      const is_parsable = startswith(text, PARSABLE_COMMENT)

      const is_redirect = cttp == JSON_REDIRECT_CONTENT_TYPE

      // @ts-expect-error TS2339
      state.IS_SUBMITTED = false

      if (is_redirect) {
        const url = JSONDecode(text).location
        return change_window_location(url)
      }

      if (!check_url_is_ajax(path)) {
        // the ajax request ended up doing an external redirect, should not happen
        // @ts-expect-error TS2322
        window.location = path.href
        return
      }

      if (!is_parsable) {
        if (cttp == "text/html") {
          document.open(cttp)
          document.write(text)
          document.close()

          // after writing a new document all the state is fucked up
          // it is a much cleaner solution to just re-perform the request when pressing back
          // @ts-expect-error TS2322
          window.onpopstate = () => (window.location = window.location.href)

          // @ts-expect-error TS2339
          navigator.push_state(url)

          return
        }

        return (
          response
            .blob()
            .then(b => BlobCreate(b, cttp).createObjectURL())
            // @ts-expect-error TS2554
            .then(url => download_url(url, ResponseFileName(response)))
        )
      }

      // @ts-expect-error TS2345
      fire_event(document, "before_json", {
        // @ts-expect-error TS2339
        counter: state.AJAX_COUNTER,
      })

      if (change_location && mode !== "prevent") {
        console.log(`current url: ${window.location.href}`)

        if (window.location.href != path.href) {
          if (mode == "replace") {
            // @ts-expect-error TS2339
            navigator.replace_state(path.href)
          } else {
            // @ts-expect-error TS2339
            navigator.push_state(path.href)
          }
        }
      }

      const scripts = []

      scan(
        el => {
          if (el.tagName == "SCRIPT") {
            scripts.push(el.innerHTML)
          } else {
            const target = document.getElementById(
              el.getAttribute("data-block-id")
            )
            const attr = el.getAttribute("data-block-replace")

            if (attr) {
              target.setAttribute(attr, el.getAttribute(attr))
            } else if (target) {
              target.replaceWith(el)
            } else {
              console.info(
                `element with block name ${el.getAttribute("data-block-id")} not found`
              )
            }
          }
        },
        selector("[data-block-id]", el("html", {}, text))
      )

      scan(eval, scripts)

      if (
        scroll_control &&
        ResponseHeader(response, "X-Scroll-Control") !== "prevent"
      ) {
        setTimeout(() => scroll_to(path.hash || parsed.hash || null), 10) // the timeout is needed to prevent the scrolling to trigger before the content is addee
      }

      // @ts-expect-error TS2339
      if (state.LAST_FOCUS) {
        // @ts-expect-error TS2339
        const input = first(selector(`#${state.LAST_FOCUS}`)) as
          | HTMLElement
          | undefined
        if (input) input.focus()
      }

      // @ts-expect-error TS2345
      fire_event(document, "after_json", {
        // @ts-expect-error TS2339
        counter: state.AJAX_COUNTER,
        // @ts-expect-error TS2339
        initial: state.AJAX_COUNTER == 0,
      })

      // @ts-expect-error TS2554
      oncomplete(response)
    })
  }
}
